import {Usuario} from './models/usuario.interface';
import {UsuarioService} from './shared/services/usuario/usuario.service';
import {ChangeDetectorRef, Component, OnInit} from '@angular/core';
import {NavigationEnd, Router} from '@angular/router';
import {MatDialog} from '@angular/material/dialog';
import {AlertEmpresaComponent} from './shared/components/alert-empresa/alert-empresa.component';

const VINTE_MINUTOS = 60000 * 20;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {

  usuario: Usuario;
  title = 'hero';

  activeRoute = '';
  role = '';
  roleView = '';

  showMenu;

  constructor(
    private readonly usuarioService: UsuarioService,
    private readonly route: Router,
    private readonly modal: MatDialog,
  ) {
    const token = window.localStorage.getItem('usuario');

    if (token) {
      const usr: Usuario = JSON.parse(token);
      this.usuario = usr;
      this.role = this.whatRole(usr?.roles[0].nome);
      this.usuarioService.showMenu.next(true);
    }





  }

  ngOnInit(): void {
    this.showMenu = this.usuarioService.showMenu;
    this.usuarioService.showMenu.subscribe(() => {
      this.role = this.whatRole(this.usuario?.roles[0].nome);
    });

    this.usuarioService.testeUsuariotk.subscribe(usuario => {
      this.usuario = usuario;
      this.role = this.whatRole(usuario?.roles[0].nome);
    });
    this.route.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.activeRoute = event.urlAfterRedirects.split('/').pop() || '';
      }
    });
  }

  whatRole(role: string) {
    switch (role) {
      case 'ROLE_ADMIN':
        this.roleView = 'Administrador';
        return 'admin';
      case 'ROLE_MASTER':
        this.roleView = 'Administrador';
        return 'master';
      case 'ROLE_USER':
        this.roleView = 'Funcionario';
        return 'user';
      default:
        return ;
    }
  }

  expireSessionUser() {
    setInterval(() => {
      this.usuarioService.removeTk();
      this.route.navigateByUrl('/login');
    }, VINTE_MINUTOS);
  }

  openModal() {
    if (this.usuario.empresa.statusEmpresa === 'INATIVA') {
        this.modal.open(AlertEmpresaComponent);
    }
  }

  logout() {
    window.localStorage.removeItem('usuario');
    this.usuarioService.removeTk();
    this.route.navigate(['/login']);
    this.usuarioService.showMenu.next(false);
  }

  isActive(route: string): boolean {
    return this.activeRoute === route;
  }

}
